import React, { createContext, useContext, useState, useEffect } from 'react';

const MockDataContext = createContext();

const MOCK_DATA_KEY = 'THAKLIS_MOCK_DATA_ENABLED';

export const useMockData = () => {
  const context = useContext(MockDataContext);
  if (!context) {
    throw new Error('useMockData must be used within MockDataProvider');
  }
  return context;
};

export const MockDataProvider = ({ children }) => {
  const [isMockDataEnabled, setIsMockDataEnabled] = useState(false);

  // Initialize from localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem(MOCK_DATA_KEY);
      if (stored !== null) {
        setIsMockDataEnabled(stored === 'true');
      }
    } catch (error) {
      console.error('Error reading mock data state:', error);
    }
  }, []);

  const enableMockData = () => {
    setIsMockDataEnabled(true);
    localStorage.setItem(MOCK_DATA_KEY, 'true');
  };

  const disableMockData = () => {
    setIsMockDataEnabled(false);
    localStorage.setItem(MOCK_DATA_KEY, 'false');
  };

  const toggleMockData = () => {
    if (isMockDataEnabled) {
      disableMockData();
    } else {
      enableMockData();
    }
  };

  const value = {
    isMockDataEnabled,
    enableMockData,
    disableMockData,
    toggleMockData,
  };

  return (
    <MockDataContext.Provider value={value}>
      {children}
    </MockDataContext.Provider>
  );
};

export default MockDataContext;
